window.lang2 = 
{
  "general": {
    "meta": {
      "tags": "Mots clés \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 - Page non trouvée",
      "subtext_html": "Cette page n'est pas disponible. <a href=\"\/collections\/all\">Retourner au magasinage<\/a>",
      "click_here": "Cliquez ici",
      "continue_shopping": "pour continuer les achats."
    },
    "breadcrumbs": {
      "home": "Accueil",
      "home_link_title": "Retour à la page d'accueil",
      "cart": "Panier"
    },
    "newsletter_form": {
      "newsletter_email": "votre-courriel@exemple.com",
      "submit": "S'inscrire",
      "newsletter_text": "Votre adresse email"
    },
    "search": {
      "no_results_html": "Votre recherche pour \"{{ terms }}\" n'a pas généré de résultats.",
      "results_for_html": "Votre recherche pour \"{{ terms }}\" a généré les résultats suivants:",
      "title": "Effectuez une recherche",
      "placeholder": "Rechercher dans la boutique",
      "submit": "Recherche"
    },
    "currency": {
      "change_text": "La devise du magasin a changé pour"
    },
    "language": {
      "lang_mb": "La langue",
      "currency_mb": "Devise"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Publié le {{ date }} par {{ author }}",
      "older_post": "Article précédent",
      "newer_post": "Article suivant",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} le {{ date }}",
      "read_more": "Plus"
    },
    "comments": {
      "title": "Laissez un commentaire",
      "name": "Nom",
      "email": "Courriel",
      "message": "Message",
      "post": "Publier le commentaire",
      "moderated": "Veuillez noter que les commentaires doivent être approvés avant d'être affichés",
      "success_moderated": "Votre commentaire a été soumis avec succès. Nous le publierons sous peu, suite à notre processus de modération.",
      "success": "Votre commentaire a été publié avec succès!",
      "comments_with_count": {
        "one": "{{ count }} commentaire",
        "other": "{{ count }} commentaires"
      },
      "note": "Tous les commentaires de blog sont vérifiés avant publication"
    },
    "sidebar": {
      "recent_articles": "Articles récents",
      "categories": "Catégories",
      "sidebar_more_blog": "Afficher la barre latérale"
    }
  },
  "cart": {
    "general": {
      "title": "Panier",
      "remove": "Retirer",
      "note": "Instructions spéciales pour la commande",
      "subtotal": "Sous-total",
      "shipping_at_checkout": "Frais de port et remises calculés à la caisse",
      "update": "Mettre à jour",
      "checkout": "Procéder au paiement",
      "empty": "Votre panier est vide.",
      "continue_browsing_html": "<a href=\"\/collections\/all\">Retourner au magasinage<\/a>.",
      "view_cart": "Voir le panier",
      "close_cart": "Fermer le panier",
      "button_checkout": "Passer à la caisse",
      "shopping_cart": "Panier",
      "shopping_cart_layout_1": "Mon sac",
      "label": "Remarque",
      "order_summary": "Récapitulatif de la commande",
      "shipping_calculator_button": "Calculer Frais de port",
      "shipping_calculator_calculating": "Calculatrice...",
      "label_text": "Commentaires additionnels",
      "shipping_calculator_error_message": "Erreur: Veuillez entrer les informations d'expédition correctes",
      "shipping_calculator_success_many_rates": {
        "there_are": "Il y a",
        "shipping_rates_available_for": "tarifs de livraison disponibles pour",
        "starting_at": ", à partir de"
      },
      "shipping_calculator_success_one_rate": "Il y a un tarif d'expédition disponible pour",
      "shipping_calculator_success_no_rate": "Il n'y a pas de frais de livraison pour cette commande et cette destination.",
      "shipping_calculator_success_at": "à"
    },
    "label": {
      "product": "Produit",
      "price": "Prix",
      "quantity": "Quantité",
      "total": "Total",
      "or": "ou"
    },
    "ajax_cart": {
      "continue_shopping": "Continuer vos achats",
      "go_to_cart": "Aller au panier",
      "success_text": "est ajouté à votre panier.",
      "error": "Erreur",
      "loading": "Chargement",
      "close": "proche"
    }
  },
  "collections": {
    "general": {
      "no_matches": "Aucun produit ne correspond à votre recherche.",
      "link_title": "Consultez la collection {{ title }}",
      "grid_view": "Grille",
      "list_view": "Liste",
      "items_count": {
        "one": "item",
        "other": "items"
      },
      "items_with_count": {
        "one": "{{ count }} item",
        "other": "{{ count }} items"
      },
      "title": "Des collections",
      "shop_the_collection": "Magasinez la collection",
      "show_more": "Montre plus",
      "no_more_product": "Plus de produit"
    },
    "sidebar": {
      "types": "Types de produits",
      "vendors": "Fournisseurs",
      "tags": "Filtres",
      "clear": "effacer",
      "clear_all": "Tout effacer",
      "refined_by": "Raffiné par"
    },
    "sorting": {
      "title": "Trier par",
      "featured": "En vedette",
      "best_selling": "Meilleurs vendeurs",
      "az": "A-Z",
      "za": "Z-A",
      "price_ascending": "Prix: faible à élevé",
      "price_descending": "Prix: élevé à faible",
      "date_descending": "Date: récent à ancien",
      "date_ascending": "Date: ancien à récent"
    },
    "toolbar": {
      "view_as": "Voir comme",
      "show": "Spectacle",
      "showing": "Montrant",
      "all": "Tout",
      "of": "de",
      "previous": "Précédent",
      "next": "Prochain",
      "refine": "Affiner par"
    }
  },
  "contact": {
    "form": {
      "name": "Nom",
      "email": "Courriel",
      "phone": "Téléphone",
      "message": "Message",
      "send": "Envoyer",
      "post_success": "Merci de nous avoir avoir contacté. Nous vous reviendrons le plus rapidement possible.",
      "placeholder_message": "S'il vous plaît laissez votre commentaire ici",
      "submit_contact": "Soumettre un contact"
    }
  },
  "customer": {
    "account": {
      "title": "Mon compte",
      "details": "Détails du compte",
      "view_addresses": "Voir les adresses",
      "return": "Retour au détails du compte"
    },
    "activate_account": {
      "title": "Activer le compte",
      "subtext": "Créez votre mot de passe pour activer le compte.",
      "submit": "Activer le compte",
      "cancel": "Refuser l'invitation",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe"
    },
    "addresses": {
      "title": "Votre adresse",
      "default": "Par défaut",
      "add_new": "Ajouter une nouvelle adresse",
      "edit_address": "Éditer l'adresse",
      "first_name": "Prénom",
      "last_name": "Nom",
      "company": "Compagnie",
      "address1": "Adresse 1",
      "address2": "Adresse 2",
      "city": "Ville",
      "country": "Pays",
      "province": "Province",
      "zip": "Code postal",
      "phone": "Téléphone",
      "set_default": "Définir comme adresse par défaut",
      "add": "Ajouter l'adresse",
      "update": "Mettre à jour l'adresse",
      "cancel": "Annuler",
      "edit": "Éditer",
      "delete": "Supprimer",
      "delete_message": "Êtes-vous sûr de vouloir supprimer cette adresse?"
    },
    "login": {
      "title": "Connexion",
      "email": "Courriel",
      "password": "Mot de passe",
      "forgot_password": "Mot de passe oublié?",
      "sign_in": "Se connecter",
      "cancel": "Retourner à la boutique",
      "guest_title": "Continuer en tant qu'invité",
      "guest_continue": "Continuer",
      "login": "S'identifier",
      "registers": "Créer un nouveau compte"
    },
    "orders": {
      "title": "Historique des commandes",
      "order_number": "Commande",
      "date": "Date",
      "payment_status": "Statut du paiement",
      "fulfillment_status": "Statut du traitement de la commande",
      "total": "Total",
      "none": "Vous n'avez pas placé de commande à ce jour."
    },
    "order": {
      "title": "Commande {{ name }}",
      "date": "Placée le {{ date }}",
      "cancelled": "Commande annulée le {{ date }}",
      "cancelled_reason": "Motif: {{ reason }}",
      "billing_address": "Adresse de facturation",
      "payment_status": "Statut du paiement",
      "shipping_address": "Adresse de livraison",
      "fulfillment_status": "Statut du traitement de la commande",
      "discount": "Rabais appliqué",
      "shipping": "Livraison",
      "tax": "Taxes",
      "product": "Produit",
      "sku": "SKU",
      "price": "Prix",
      "quantity": "Quantité",
      "total": "Total",
      "fulfilled_at": "Traitée le {{ date }}",
      "subtotal": "Sous-total"
    },
    "recover_password": {
      "title": "Réinitialiser votre mot de passe",
      "email": "Courriel",
      "submit": "Soumettre",
      "cancel": "Annuler",
      "subtext": "Nous vous ferons parvenir un courriel pour réinitialiser votre mot de passe.",
      "success": "Nous vous avons fait parvenir un courriel pour réinitialiser votre mot de passe."
    },
    "reset_password": {
      "title": "Réinitialiser le mot de passe du compte",
      "subtext": "Entrez un nouveau mot de passe pour {{ email }}",
      "submit": "Réinitialiser le mot de passe",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe"
    },
    "register": {
      "title": "Créer un compte",
      "first_name": "Prénom",
      "last_name": "Nom",
      "email": "Courriel",
      "submit": "Créer",
      "cancel": "Retour à la boutique",
      "password": "Mot de passe"
    },
    "form": {
      "error_message": "Désolé, on dirait que quelque chose s'est mal passé. Veuillez corriger les informations suivantes et soumettre à nouveau:"
    }
  },
  "home_page": {
    "sections": {
      "frontpage_title": "Collection Frontpage",
      "featured_title": "Collections en vedette",
      "news_title": "Nouvelles récentes"
    },
    "onboarding": {
      "modal_title": "Nous y sommes presque...",
      "no_products_html": "Vous n'avez pas de produit dans votre collection Frontpage. Ce message apparaitra jusqu'à ce qu'un produit soit <a href=\"\/admin\/collections?tutorial=Frontpage\">ajouté à cette collection<\/a>.",
      "add_product": "Ajouter un produit",
      "product_title": "Titre du produit",
      "no_collections_html": "Vous n'avez pas de collection à afficher ici. <a href=\"\/admin\/custom_collections\">Ajoutez une ou plusieurs collections<\/a> pour compléter la page d'accueil par défaut.",
      "add_collection": "Ajouter une collection",
      "collection_title": "Titre de la collection"
    },
    "show_more": "Afficher plus de produits",
    "no_more_product": "Plus de produit"
  },
  "layout": {
    "cart": {
      "title": "Panier",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Compte",
      "logged_in_as_html": "Connecté en tant que {{ first_name }}",
      "log_out": "Se déconnecter",
      "log_in": "Se connecter",
      "create_account": "Créer un compte",
      "create_account_layout_3": "S'inscrire"
    },
    "footer": {
      "linklist_title": "Liens rapides",
      "social_title": "Restez en contact",
      "newsletter_title": "Infolettre",
      "accepted_payments": "Méthodes de paiement acceptées"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Produit précédent",
      "next_product_html": "Produit suivant &rarr;",
      "from": "À partir de"
    },
    "product": {
      "sold_out": "Épuisé",
      "on_sale_from_html": "<strong>En solde<\/strong> {{ price }}",
      "unavailable": "Non disponible",
      "compare_at": "Était",
      "quantity": "Quantité",
      "add_to_cart": "Ajouter au panier",
      "sale": "Vente",
      "new": "Nouveau",
      "select_options": "Sélectionnez les options",
      "show_options": "Montrer les variantes",
      "hide_options": "masquer les variantes",
      "adding": "Ajouter",
      "quick_view": "Aperçu rapide",
      "thank_you": "Merci",
      "add_more": "Ajouter plus de",
      "in_stock": "En stock",
      "cart_feedback": "ajouté à votre panier",
      "out_of_stock": "En rupture de stock",
      "many_in_stock": "Beaucoup en stock",
      "free_shipping": "Livraison gratuite",
      "buy_now": "Acheter maintenant",
      "details": "Détails",
      "from": "de"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Votre carte-cadeau {{ shop }} d'une valeur de {{ value }}!",
      "subtext": "Voici votre carte-cadeau!",
      "disabled": "Désactivée",
      "expired": "Expirée le {{ expiry }}",
      "active": "Expire le {{ expiry }}",
      "redeem": "Entrez ce code lors du paiement pour utiliser votre carte-cadeau",
      "shop_link": "Boutique",
      "print": "Imprimer"
    }
  },
  "date_formats": {
    "month_day_year": "%d %B, %Y"
  },
  "slideshow": {
    "next_slide": "Diapositive suivante",
    "previous_slide": "Diapositive précédente",
    "pause_slideshow": "Pause diaporama",
    "play_slideshow": "Lancer le diaporama",
    "play_video": "Lire la vidéo",
    "close_video": "Fermer la vidéo"
  },
  "wishlist": {
    "general": {
      "my_wishlist": "Liste de voeux",
      "my_wishlist_layout_1": "Mes favoris",
      "product_image": "Image du produit",
      "product_name": "Nom du produit",
      "unit_price": "Prix unitaire",
      "share_wishlist": "Partager ma liste de souhaits par e-mail",
      "no_login_html": "Pour créer une liste de souhaits, vous devez <a href=\"\/account\/login\">se connecter<\/a> ou <a href=\"\/account\/register\">créer un compte<\/a>.",
      "add_to_wishlist": "Ajouter à la liste de souhaits",
      "added_to_wishlist": "Ajouté à la liste de souhaits",
      "remove_wishlist": "Ajouté à la liste de souhaits",
      "note": "Déjà dans votre liste de souhaits, Aller à la liste de souhaits",
      "subtext": "Pour créer une liste de souhaits, vous devez",
      "sign_in": "S'identifier",
      "or": "ou",
      "create_account": "S'inscrire"
    },
    "ajax_wishlist": {
      "go_to_wishlist": "Aller à la liste de souhaits",
      "success_text": "est ajouté à votre liste de souhaits."
    }
  }
}